export default __webpack_public_path__ + "static/media/P00124182_WF_BRAND_1HFY24ISF_Art11_767x577.37a2f236.jpg";